import { useNavigate } from "react-router-dom";
import "./PublicHeader.css";

export default function PublicHeader() {
  const navigate = useNavigate();

  return (
    <header className="public-header">
      {/* LOGO */}
      <div className="public-header-left" onClick={() => navigate("/")}>
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick Logo"
          className="public-header-logo"
        />
      </div>

      {/* LINKS + LOGIN */}
      <nav className="public-header-right">
        <button className="public-header-link" onClick={() => navigate("/privacy")}>
          Politica de Privacidade
        </button>

        <button className="public-header-link" onClick={() => navigate("/sobre")}>
          Sobre
        </button>


        <button className="public-header-link" onClick={() => navigate("/contato")}>
          Contato
        </button>

        <button
          className="public-header-login"
          onClick={() => navigate("/login")}
        >
          Login
        </button>
      </nav>
    </header>
  );
}
